// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Image----Image-module---container---2NyyH","loaderBG":"src-components-Image----Image-module---loaderBG---1mKT_","active":"src-components-Image----Image-module---active---xVjZw","loaderIcon":"src-components-Image----Image-module---loaderIcon---wcHSc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Image/Image.module.less
// module id = 343
// module chunks = 153596302435155